// extracted by mini-css-extract-plugin
export default {"heading":"NotionBoard_heading__2XsFL","link":"NotionBoard_link__MUfim"};